function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 341.337,
  width: 512,
  height: 170.663
});

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg007Iraq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#A2001D"
    },
    width: 512,
    height: 170.663
  }), _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M208.152,242.758c-0.111,0-0.22,0.007-0.331,0.009v-0.009H169.01   c1.968-7.602,8.867-13.242,17.074-13.242v-26.483c-24.338,0-44.138,19.8-44.138,44.138V268.8v0.442h65.875c0.149,0,0.266,0,0.331,0   c2.433,0,4.414,1.98,4.414,4.414v8.828h-88.275v26.483h114.757v-35.31C239.048,256.619,225.189,242.758,208.152,242.758z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "274.359,282.483 274.359,203.035 247.876,203.035 247.876,308.965 292.014,308.965    292.014,282.483  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "362.635,282.484 362.635,203.035 336.152,203.035 336.152,282.484 327.325,282.484    327.325,256.001 300.841,256.001 300.841,308.966 380.29,308.966 380.29,282.484  "
  })), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg007Iraq);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxyZWN0IHN0eWxlPSJmaWxsOiNBMjAwMUQ7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjE3MC42NjMiLz4KPHJlY3QgeT0iMzQxLjMzNyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIxNzAuNjYzIi8+CjxnPgoJPHBhdGggc3R5bGU9ImZpbGw6IzQ5NkUyRDsiIGQ9Ik0yMDguMTUyLDI0Mi43NThjLTAuMTExLDAtMC4yMiwwLjAwNy0wLjMzMSwwLjAwOXYtMC4wMDlIMTY5LjAxICAgYzEuOTY4LTcuNjAyLDguODY3LTEzLjI0MiwxNy4wNzQtMTMuMjQydi0yNi40ODNjLTI0LjMzOCwwLTQ0LjEzOCwxOS44LTQ0LjEzOCw0NC4xMzhWMjY4Ljh2MC40NDJoNjUuODc1YzAuMTQ5LDAsMC4yNjYsMCwwLjMzMSwwICAgYzIuNDMzLDAsNC40MTQsMS45OCw0LjQxNCw0LjQxNHY4LjgyOGgtODguMjc1djI2LjQ4M2gxMTQuNzU3di0zNS4zMUMyMzkuMDQ4LDI1Ni42MTksMjI1LjE4OSwyNDIuNzU4LDIwOC4xNTIsMjQyLjc1OHoiLz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiM0OTZFMkQ7IiBwb2ludHM9IjI3NC4zNTksMjgyLjQ4MyAyNzQuMzU5LDIwMy4wMzUgMjQ3Ljg3NiwyMDMuMDM1IDI0Ny44NzYsMzA4Ljk2NSAyOTIuMDE0LDMwOC45NjUgICAgMjkyLjAxNCwyODIuNDgzICAiLz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiM0OTZFMkQ7IiBwb2ludHM9IjM2Mi42MzUsMjgyLjQ4NCAzNjIuNjM1LDIwMy4wMzUgMzM2LjE1MiwyMDMuMDM1IDMzNi4xNTIsMjgyLjQ4NCAzMjcuMzI1LDI4Mi40ODQgICAgMzI3LjMyNSwyNTYuMDAxIDMwMC44NDEsMjU2LjAwMSAzMDAuODQxLDMwOC45NjYgMzgwLjI5LDMwOC45NjYgMzgwLjI5LDI4Mi40ODQgICIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };